<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M12.6745 12.6745L22 8.81179L31.3255 12.6745L35.1882 22L31.3255 31.3255L22 35.1882L12.6745 31.3255L8.81179 22L12.6745 12.6745Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
